"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwimLevel = void 0;
var SwimLevel;
(function (SwimLevel) {
    SwimLevel[SwimLevel["SpringWater"] = 1] = "SpringWater";
    SwimLevel[SwimLevel["NormalWater"] = 2] = "NormalWater";
    SwimLevel[SwimLevel["ChillWater"] = 6] = "ChillWater";
    SwimLevel[SwimLevel["Lava"] = 8] = "Lava";
})(SwimLevel || (exports.SwimLevel = SwimLevel = {}));
